import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../redux/Store';
import { fetchCurrentUser } from '../redux/thunks/authThunks';

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * AuthProvider component that initializes authentication on app load
 * Checks if user has a valid access token and fetches user data
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('accessToken');

      if (token) {
        try {
          // Try to fetch current user with existing token
          await dispatch(fetchCurrentUser()).unwrap();
        } catch (error) {
          // Token is invalid, will be handled by thunk (logout)
          console.error('Auth initialization failed:', error);
        }
      }

      setIsInitialized(true);
    };

    initAuth();
  }, [dispatch]);

  // Show loading screen while initializing auth
  if (!isInitialized) {
    return (
      <div className="app-loading">
        <div className="loading-spinner">Initializing...</div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthProvider;
